module.exports = __webpack_public_path__ + "static/media/Intro.b1609666.pdf";